__turbopack_context__.v({
  "slide": "_4eAAGa_slide",
});
